import { getCurrentEnvForClientSide, PRODUCTION } from '@zg-rentals/rental-platform-config';
import { getNamespace } from '@zg-rentals/environment-utils';

export const isProd =
  typeof window === 'undefined' ? getNamespace() === 'production' : getCurrentEnvForClientSide() === PRODUCTION;
const CREDIT_TRACKING_APP_KEY = 'BE7AECF2-1F77-4A7F-86D2-C8FAA906D430';

export const CREDIT_TRACKING_CONFIG = {
  appKey: CREDIT_TRACKING_APP_KEY,
  apiUrl: isProd ? 'https://embed.array.io/cms' : 'https://embed.sandbox.array.io/cms',
  baseScriptURL: isProd
    ? 'https://embed.array.io/cms/array-web-component.js'
    : 'https://embed.sandbox.array.io/cms/array-web-component.js',
} as const;

export const getCreditTrackingScripts = (enableCreditTracking: boolean) =>
  enableCreditTracking
    ? [
        {
          type: 'text/javascript',
          src: CREDIT_TRACKING_CONFIG.baseScriptURL,
          async: true,
          defer: true,
        },
        {
          type: 'text/javascript',
          src: `${CREDIT_TRACKING_CONFIG.apiUrl}/array-account-enroll.js?appKey=${CREDIT_TRACKING_CONFIG.appKey}`,
          async: true,
          defer: true,
        },
        {
          type: 'text/javascript',
          src: `${CREDIT_TRACKING_CONFIG.apiUrl}/array-credit-overview-mini.js?appKey=${CREDIT_TRACKING_CONFIG.appKey}`,
          async: true,
          defer: true,
        },
      ]
    : [];

export const CREDIT_REPORTING_FAQ_URL =
  'https://www.zillow.help/article/rent-reporting-to-credit-bureaus-zd32878506716819/';
export const CREDIT_REPORTING_TERMS_AND_CONDITIONS_URL =
  'https://www.zillow.com/rent/rent-reporting-terms-and-conditions/';
export const CREDIT_REPORTING_PRIVACY_POLICY_URL = 'https://www.zillowgroup.com/zg-privacy-policy/';
